import ProductDetail from '~/types/api/ProductDetail'
import SectionHelper from '~/utils/sectionHelper'

export function getCanonical (product: ProductDetail, seoUrl: string, helper: SectionHelper, host: string): string {
  let shortyUrl: string = ''
  product.categoryIds.map((c, i) => {
    const currentUrl = helper.getProductLink(c, seoUrl ?? product.id)
    console.log(currentUrl)
    if (i === 0) {
      shortyUrl = currentUrl
    } else if (shortyUrl.split('/').length > currentUrl.split('/').length) {
      shortyUrl = currentUrl
    }
  })

  return host + shortyUrl
}
